import { API_PATH } from './ApiPath'

let BUCKET
export const ACCESS_KEYID = 'AKIAQXRIUSCIQS3JLXOQ'
export const SECRET_ACCESS_KEY = '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'

// // TEMP: set true when running locally against a production DB dump.
// // Site id 1 / uniservedapi.orion22.com data uses matrix-private-bucket-files.
// // Use orion-private-bucket-files instead if your prod DB is from api.orion22.com.
// const LOCAL_DEV_USE_PRODUCTION_S3 = false
// const LOCAL_DEV_PRODUCTION_S3_BUCKET = 'matrix-private-bucket-files'

// if (API_PATH === 'https://api.orion22.com/api/v1' ){
//     BUCKET = 'orion-private-bucket-files'
// } else if (API_PATH === 'https://uniservedapi.orion22.com/api/v1' ){
//     BUCKET = 'matrix-private-bucket-files'
// } else if (API_PATH === 'https://stagingapi.orion22.com/api/v1'){
//     BUCKET = 'test-bucket-private-classy'
// } else if (API_PATH === 'http://127.0.0.1:8000/api/v1'){
//     BUCKET = LOCAL_DEV_USE_PRODUCTION_S3
//         ? LOCAL_DEV_PRODUCTION_S3_BUCKET
//         : 'test-bucket-private-classy'
// }else{
//     BUCKET = 'test-bucket-private-classy'
// }


if (API_PATH === 'https://api.orion22.com/api/v1' ){
    BUCKET = 'orion-private-bucket-files'
} else if (API_PATH === 'https://uniservedapi.orion22.com/api/v1' ){
    BUCKET = 'matrix-private-bucket-files'
} else if (API_PATH === 'https://stagingapi.orion22.com/api/v1'){
    BUCKET = 'test-bucket-private-classy'
} else if (API_PATH === 'http://127.0.0.1:8000/api/v1'){
    BUCKET = 'test-bucket-private-classy'
}else{
    BUCKET = 'test-bucket-private-classy'
}

export const BUCKET_NAME = BUCKET
